export default "<div class=\"error-message\">\n    <span  *ngIf=\"!appSpinnerService.appSpinner\">\n        No record found !\n    </span>\n</div>"